export default "__VITE_ASSET__d092c96a__"